import React, { useState, useEffect, useMemo } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import api from '../../services/apiService';
import './FAQPage.css';

const FAQPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState('All');

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await api.get('/faq');
        setFaqs(response.data);
      } catch (err) {
        console.error('Failed to fetch FAQs:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchFaqs();
  }, []);

  const categories = useMemo(() => {
    const cats = [...new Set(faqs.map(f => f.category))];
    return ['All', ...cats];
  }, [faqs]);

  const filteredFaqs = useMemo(() => {
    if (selectedCategory === 'All') return faqs;
    return faqs.filter(f => f.category === selectedCategory);
  }, [faqs, selectedCategory]);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="faq-page">
      <Header />
      
      <main className="faq-page-main">
        <section className="faq-hero">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to the most common questions about our platform</p>
        </section>

        <section className="faq-content">
          {loading ? (
            <div className="faq-loading">Loading FAQs...</div>
          ) : faqs.length === 0 ? (
            <div className="faq-empty">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
              <h3>No FAQs available</h3>
              <p>Check back later for frequently asked questions.</p>
            </div>
          ) : (
            <>
              {categories.length > 2 && (
                <div className="faq-categories">
                  {categories.map(cat => (
                    <button
                      key={cat}
                      className={`faq-category-btn ${selectedCategory === cat ? 'active' : ''}`}
                      onClick={() => { setSelectedCategory(cat); setOpenIndex(0); }}
                    >
                      {cat}
                    </button>
                  ))}
                </div>
              )}

              <div className="faq-accordion">
                {filteredFaqs.map((faq, index) => (
                  <div key={faq.id} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
                    <div className="faq-item-header" onClick={() => toggleFaq(index)}>
                      <span className="faq-item-question">{faq.question}</span>
                      <span className="faq-item-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#637381" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-item-answer">
                        {faq.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default FAQPage;
